<script setup>
import '@/assets/cloudCounter/css/style.css';
import { ref } from 'vue';
import Layout from '@/components/cloudCounter/Layout.vue';
import CaseBox from '@/components/cloudCounter/CaseBox.vue';
import InfoBox from '@/components/cloudCounter/InfoBox.vue';
import Process from '@/components/cloudCounter/Process.vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const goNextPage = () => {
    router.push({ name:'cloudCounterVideoOperationVerify' });
}

// #region 匯款帳號
const accountInfo = ref(null);

// 串接...
accountInfo.value = { key: '銀行帳號', value: '0120000 台北富邦商業銀行南京東路分行<br>00001234234567' };
// #endregion

// #region 借款明細
const moneyInfo = ref(null);
const caseItemList = ref(null);

// 串接...
moneyInfo.value = { key: '共欲借款總金額', value: '$100,000', flexClass: 'justify-between' };
caseItemList.value = [
    {
        boxList: [
            {
                title: 'XWO 富邦人壽富利旺終身壽險',
                subTitle: '1068302189-00',
                iconTitle: '',
                flexClass: '', // 空白則預設垂直排列，若要每列項目對齊左右兩側:justify-between
                list: [
                    { key: '本月利率（年利率）', value: '5.75%' },
                    { key: '借款幣別', value: '新臺幣' },
                    { key: '借款金額', value: '$66,000' }
                ]
            }
        ]
    },
    {
        boxList: [
            {
                title: 'XWO 富邦人壽富利旺終身壽險',
                subTitle: '1068302189-00',
                iconTitle: '申請優惠利率方案',
                flexClass: '', // 空白則預設垂直排列，若要每列項目對齊左右兩側:justify-between
                list: [
                    { key: '本月利率（年利率）', value: '5.75%' },
                    { key: '借款幣別', value: '新臺幣' },
                    { key: '借款金額', value: '$66,000' }
                ]
            }
        ]
    }
];
// #endregion

const infoBoxVisble = ref(false);
const okHandel = () => {

};

</script>

<template>

    <!-- 保單借款 -->
    <Layout :header="{ text: '申請內容', backBtn: { visible: true }, closeBtn: { visible: false, to: {} }, }">

        <div class="pt-2 pb-6">
            <Process :steps="['服務條款', '查看內容', '視訊驗證', '身份認證']" :index="1"></Process>
        </div>

        <div class="pb-6">
            <h2 class="pb-3 text-2xl font-bold">
                申請紀錄
            </h2>
            <CaseBox :caseBox="{
                boxList: [
                    {
                        list: [
                            { key: '申請日期', value: '113/06/15' },
                            { key: '申請項目', value: '保單借款' },
                            { key: '受理案號', value: '114-WBP-0023902' },
                            { key: '視訊時間', value: '113/07/02 10:00~11:00' },
                            { key: '處理狀態', value: '待視訊確認中' }
                        ]
                    }
                ]
            }" />
        </div>

        <h2 class="pb-3 text-2xl font-bold">
            申請明細
        </h2>

        <div class="pb-6">
            <h3 class="pb-4 text-xl font-bold">
                匯款帳號
            </h3>
            <CaseBox :caseBox="accountInfo"></CaseBox>
        </div>

        <div>
            <h3 class="pb-4 text-xl font-bold">
                借款明細
            </h3>
            <CaseBox :caseBox="moneyInfo"></CaseBox>
            <CaseBox :caseBox="caseBox" :key="i" v-for="(caseBox, i) in caseItemList"></CaseBox>
        </div>

        <div class="text-center">
            <button class="py-3 text-[#EB4751] text-sm" @click="(e) => { infoBoxVisble = true }">取消預約申請</button>
        </div>

        <template v-slot:bottom>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                @click="goNextPage">開始視訊</button>
        </template>

    </Layout>

    <InfoBox v-show="infoBoxVisble" :closeHandel="() => { infoBoxVisble = false; }" title="確定要取消預約申請嗎？" type="confirm"
        :okHandel="okHandel" :buttonText="{ no: '保留預約', yes: '取消預約' }" />

</template>

<style scoped></style>
